import { Systemlog } from '../systemlog.model';
import { SystemlogActions, SystemlogActionTypes } from '../actions/systemlog.actions';

export interface State {
  Loaded: boolean;
  Loading: boolean;
  entities: any;
}

export const initialState: State = {
  Loaded: false,
  Loading: false,
  entities: null
};

export interface SystemlogTypeState {
  Loaded: boolean;
  Loading: boolean;
  entities: any;
}

export const initialStateforSystemlogTypeState: SystemlogTypeState = {
  Loaded: false,
  Loading: false,
  entities: null
};

export function reducer(
  state = initialState,
  action: SystemlogActions
): State {
  switch (action.type) {

    case SystemlogActionTypes.UpsertSystemlogs: {
      return {...state, Loaded: true, Loading: false, entities: action.payload};
    }

    case SystemlogActionTypes.GetSystemlogs: {
      return {...state, Loaded: false, Loading: true, entities: action.payload};
    }

    case SystemlogActionTypes.GetSystemlogsFail: {
      return {...state, Loaded: true, Loading: false, entities: action.payload};
    }

    default: {
      return state;
    }
  }
}

export function systemlogTypeReducer(state: SystemlogTypeState = initialStateforSystemlogTypeState, action: SystemlogActions): SystemlogTypeState {

  switch (action.type) {
    case SystemlogActionTypes.GetSystemlogsType: {
      return {...state, Loaded: false, Loading: true};
    }
    case SystemlogActionTypes.GetSystemlogsTypeFail: {
      return {...state, Loaded: true, Loading: false};
    }
    case SystemlogActionTypes.UpsertSystemlogsType: {
      return {...state, Loaded: true, Loading: false , entities: action.payload};
    }
    default:
    return state;
  }
}

export const getSystemlogTypeState = (state: SystemlogTypeState) => state;
